import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from '../../../lib/constants';
import { useNotification } from "../../../contexts/NotificationContext";

export const useScanUpload = (uhid_no) => {
  const { showNotification } = useNotification();
  const [scans, setScans] = useState([]);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPatientFiles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/patient_files/${uhid_no}`);
      const existingScans = response.data.files.map((file, index) => ({
        id: `server-${index}`,
        description: file.description,
        fileUrl: file.file_url,
        isNew: false,
      }));
      setScans(existingScans);
    } catch (error) {
      console.error("Error fetching patient files:", error);
      showNotification("error", "Failed to load patient files.");
    }
  };

  useEffect(() => {
    if (uhid_no) {
      fetchPatientFiles();
    }
  }, [uhid_no]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleAddScan = () => {
    if (file && description) {
      const newScan = {
        id: `local-${Date.now()}`,
        description,
        fileUrl: URL.createObjectURL(file),
        file,
        isNew: true,
      };
      setScans([...scans, newScan]);
      setFile(null);
      setDescription("");
      const fileInput = document.getElementById("fileInput");
      if (fileInput) fileInput.value = "";
      showNotification("success", "Scan added to list!");
    } else {
      showNotification("error", "Please provide both description and a file.");
    }
  };

  const handleRemoveScan = (id) => {
    setScans(scans.filter((scan) => scan.id !== id));
    showNotification("success", "Scan removed from list.");
  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();

    const newScans = scans.filter((scan) => scan.isNew);
    if (newScans.length === 0) {
      showNotification("error", "No new scans to upload.");
      return;
    }

    setLoading(true);
    try {
      for (let scan of newScans) {
        const formData = new FormData();
        formData.append("uhid_no", uhid_no);
        formData.append("description", scan.description);
        formData.append("files", scan.file);

        await axios.post(`${API_BASE_URL}/upload_patient_files`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      showNotification("success", "Scans uploaded successfully!");
      setDescription("");
      setFile(null);
      const fileInput = document.getElementById("fileInput");
      if (fileInput) fileInput.value = "";

      await fetchPatientFiles();
    } catch (error) {
      console.error("Upload error:", error);
      const msg = error.response?.data?.error || "Error uploading scans.";
      showNotification("error", msg);
    } finally {
      setLoading(false);
    }
  };

  return {
    scans,
    description,
    file,
    loading,
    handleFileChange,
    handleDescriptionChange,
    handleAddScan,
    handleRemoveScan,
    handleSubmit
  };
};
